import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

interface IDateTime {
    start: string;
    end: string;
}

@Component({
    selector: '[zoom-date-time-checkbox]',
    templateUrl: './date-time-checkbox.component.html',
    styleUrls: ['./date-time-checkbox.component.scss']
})
export class DateTimeCheckboxComponent implements OnInit {
    @Input() dateTime: IDateTime = null;
    @Input() selectedTimeStart = '';
    @Output() onSelectTime = new EventEmitter<IDateTime>();

    constructor() {}

    ngOnInit() {}

    public onSelect(dateTime: IDateTime) {
        this.onSelectTime.emit(dateTime);
    }
}
